<div>
  <app-label [for]="name" [label]="label" *ngIf="showLabel"></app-label>
  <textarea
    (blur)="onTouched()"
    (ngModelChange)="onChange($event)"
    [(ngModel)]="value"
    [id]="name"
    [name]="name"
    [rows]="noOfLines"
  >
  </textarea>
  <span *ngIf="showError">{{error}}</span>
</div>
